(function () {
  'use strict';

  angular
    .module('home')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('root.home', {
        url: '/home',
        views: {
          'content@': {
            templateUrl: 'home/home.tpl.html',
            controller: 'HomeCtrl',
            controllerAs: 'home'
          }
        },
        data: {
          titulo: 'Home'
        }
      });
  }
}());
